// /frontend/src/plugins/pinia.ts

/**
 * Pinia plugin setup.
 * This file creates and configures the Pinia instance for state management.
 *
 * @author Alexander Funke
 * @lastChange 2025-08-25
 */

import { createPinia } from 'pinia';

const pinia = createPinia();

export default pinia;
